<div class="question-view__error-container fs__sm">
  @if (question.type !== questionType.Carousel && questionCtrl.invalid && questionCtrl.touched && questionCtrl.errors) {
    @if (questionCtrl.errors.required) {
      <span>Required</span>
    }
    @if (questionCtrl.errors.requiredOtherText) {
      <span>Other text is required</span>
    }
    @if (questionCtrl.errors.email) {
      <span>Please type a valid email</span>
    }
    @if (questionCtrl.errors.minlength) {
      <span>Text must have a minimum of {{ questionCtrl.errors.minlength.requiredLength }} characters</span>
    }
    @if (questionCtrl.errors.maxlength) {
      <span>Text must have a maximum of {{ questionCtrl.errors.maxlength.requiredLength }} characters</span>
    }
    @if (questionCtrl.errors.min) {
      <span>Minimum valid number is {{ questionCtrl.errors.min.required }}</span>
    }
    @if (questionCtrl.errors.max) {
      <span>Maximum valid number is {{ questionCtrl.errors.max.required }}</span>
    }
    @if (questionCtrl.errors.minAreas) {
      <span>Please select at least {{ questionCtrl.errors.minAreas }} areas</span>
    }
    @if (questionCtrl.errors.maxAreas) {
      <span>Maximum areas allowed is {{ questionCtrl.errors.maxAreas }}</span>
    }
    @if (questionCtrl.errors.minFiles) {
      <span>Please upload at least {{ questionCtrl.errors.minFiles }} file/s</span>
    }
    @if (questionCtrl.errors.maxFiles) {
      <span>No more than {{ questionCtrl.errors.maxFiles }} file/s can be uploaded</span>
    }
  }

  @if (question.type === questionType.Carousel && questionCtrl.invalid && questionCtrl.touched) {
    <span>Required</span>
  }
</div>
